// eslint-disable-next-line import/no-cycle
import responseHandler from "../system/server-response-handler";
import {
  getRequest,
  putRequest,
  postRequest,
  putRequestWithFormData,
} from "../system/server-call";

const getUnassignedReelEvents = () => {
  return getRequest("/api/v1/admin/reel/GetEventReels", true).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getAssignedReelEvents = (
  pageSize,
  pageIndex,
  status,
  filterExpression,
  orderBy = "Id desc"
) => {
  return getRequest(
    `/api/v1/admin/reel/?PageSize=${pageSize}&PageNumber=${pageIndex}&Status=${status}&FilterExpression=${filterExpression}&OrderBy=${orderBy}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const assignReelEventToShutterb = (data) => {
  return putRequest(`/api/v1/admin/reel/${data.id}`, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const removeAssignedReelShutterb = (id) => {
  return putRequest(
    `/api/v1/admin/reel/RemoveReelAssignee/${id}`,
    id,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getReelDetails = (reelId) => {
  return getRequest(`/api/v1/admin/reel/GetReelBrief/${reelId}`, true).then(
    (response) => {
      return responseHandler.handleServerResponse(response);
    },
    (error) => {
      return responseHandler.handleHTTPResponses(error.response);
    }
  );
};

const getReelTypes = () => {
  return getRequest(`/api/v1/admin/reel/GetReelTemplates`, true).then(
    (response) => {
      return responseHandler.handleServerResponse(response);
    },
    (error) => {
      return responseHandler.handleHTTPResponses(error.response);
    }
  );
};

const getRecapTypes = () => {
  return getRequest(`/api/v1/admin/reel/GetReelModeConfigurations`, true).then(
    (response) => {
      return responseHandler.handleServerResponse(response);
    },
    (error) => {
      return responseHandler.handleHTTPResponses(error.response);
    }
  );
};

const getReelTypeById = (id) => {
  return getRequest(`/api/v1/admin/reel/GetReelTypeById/${id}`, true).then(
    (response) => {
      return responseHandler.handleServerResponse(response);
    },
    (error) => {
      return responseHandler.handleHTTPResponses(error.response);
    }
  );
};

const addReelType = (data) => {
  return postRequest(`/api/v1/admin/reel/AddReelType`, data, true).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateRecapType = (data) => {
  return putRequestWithFormData(
    `/api/v1/admin/reel/UpdateReelModeConfigurations`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateReelType = (id, data) => {
  return putRequest(`/api/v1/admin/reel/UpdateReelType/${id}`, data, true).then(
    (response) => responseHandler.handleServerMessageResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const removeReelType = (id) => {
  return putRequest(`/api/v1/admin/reel/RemoveReelType/${id}`, true).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getRecapFeedback = (pageSize, pageNumber, status) => {
  return getRequest(
    `/api/v1/EventGalleryChange/Admin/GetAll/${status}/${pageNumber}/${pageSize}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getReelsByEventId = (eventId) => {
  return getRequest(
    `/api/v1/admin/reel/GetReelsByEventId/${eventId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getReelsByEventGroupId = (eventGroupId) => {
  return getRequest(
    `/api/v1/admin/reel/GetReelsByEventGroupId/${eventGroupId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

// exporting functions for other files
export const reelsServices = {
  getAssignedReelEvents,
  getUnassignedReelEvents,
  assignReelEventToShutterb,
  removeAssignedReelShutterb,
  getReelDetails,
  getReelTypes,
  getReelTypeById,
  addReelType,
  updateReelType,
  removeReelType,
  updateRecapType,
  getRecapTypes,
  getRecapFeedback,
  getReelsByEventId,
  getReelsByEventGroupId,
};
